/**
 * sortLeadsForColumn — Pure Function (BOARD-05 + PR 3, 01.06.).
 *
 * Filtert Leads auf den uebergebenen Status und sortiert nach Spalten-Regel:
 * - oldest_first → entered_status_at ASC (aelteste oben)
 * - newest_first → entered_status_at DESC (zuletzt in die Spalte gewechselt oben)
 *
 * PR 3 (01.06.): newest_first sortiert ueber enteredStatusAt statt updatedAt.
 * Begruendung: updatedAt aendert sich auch bei Tag-Edits, Note-Edits,
 * Assigned-User-Aenderungen — alle ohne dass die Karte "neuer" in der Spalte
 * waere. enteredStatusAt ist der Status-Wechsel-Zeitpunkt und reflektiert
 * "aktuelle Aktivitaet in dieser Spalte" praeziser.
 *
 * Pure: kein Mutieren der Input-Liste, kein Datum-Mocking noetig.
 */

import type { Lead, LeadStatus } from '../types';
import { COLUMNS } from './columns';

export function sortLeadsForColumn(leads: Lead[], status: LeadStatus): Lead[] {
  const col = COLUMNS.find((c) => c.status === status);
  const sortMode = col?.sort ?? 'newest_first';

  const inColumn = leads.filter((l) => l.status === status);

  if (sortMode === 'oldest_first') {
    return [...inColumn].sort(
      (a, b) =>
        new Date(a.enteredStatusAt).getTime() - new Date(b.enteredStatusAt).getTime(),
    );
  }
  return [...inColumn].sort(
    (a, b) =>
      new Date(b.enteredStatusAt).getTime() - new Date(a.enteredStatusAt).getTime(),
  );
}
